<template>
  <router-view />
</template>

<script>
export default {
  name: 'ProductStorageStocktakingIndex'
}
</script>
